<template>
	<div class="container bg-white p-3 border-15 shadow">
		<multi_step_progress
		:stepper_array="['احراز هویت', 'اطلاعات فردی', 'اطلاعات تکمیلی', 'اطلاعات تدریس', 'اطلاعات تحصیلی', 'درباره من', 'ارزیابی']"
		:stepper_warning="[]"
		:stepper_danger="[]"
		:completed="6"
		/>
		<p class="m-0">
			نتیجه ارزیابی

		</p>
		<btn
		type="success" 
		:img="require('../../assets/img/tick_white.svg')" 
		style="margin-top: 33px;"
		text="تایید شد"
		/>
		<div class="w-100 overflow-hidden mt-3 mb-3">
		<!-- ---------------------------------------------سطح کاربر---------------------------------------------- -->
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 float-right"
			:class="(windowWidth > 770) ? 'pr-0' : 'p-0'">
			<div class=" border border-15 text-center p-3" style="background-color:#FFFCF7; font-size: 12px;">
				سطح شما
				<p class="font-weight-bold text-center" style="font-size: 16px;">
					سطح
					{{ val.value.level }}
				</p>
				<img :src="require('../../assets/img/level_' + val.value.level + '.svg')" width="50" v-if="val.value.level>0 && val.value.level<5" />
				<img :src="require('../../assets/img/level_1.svg')" width="50" v-if="val.value.level==0" />
			</div>
		</div>
		<!-- ---------------------------------------------زمان کلاس---------------------------------------------- -->
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 float-right p-0">
			<div class=" border border-15 text-center p-3" style="background-color:#FFFCF7; font-size: 12px;">
				مدت زمان هر جلسه
				<p class="font-weight-bold text-center" style="font-size: 16px;">
					{{ ["", "30", "45", "60", "90"][val.value.time_class] }}
					دقیقه
				</p>
				<img :src="require('../../assets/img/time_class.svg')" width="50" />
			</div>
		</div>
		<!-- ---------------------------------------------قیمت کلاس---------------------------------------------- -->
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 float-right pl-0">
			<div class=" border border-15 text-center p-3" style="background-color:#FFFCF7; font-size: 12px;">
				حداکثر قیمت هر جلسه
				<p class="font-weight-bold text-center" style="font-size: 16px;">
					{{ ["", "300", "400", "500", "600"][val.value.price_class] }}
					تومان
				</p>
				<img :src="require('../../assets/img/price_class.svg')" width="50" />
			</div>
		</div>
		<!-- ---------------------------------------------پورسانت---------------------------------------------- -->
		<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 float-right"
			:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
			<div class=" border border-15 text-center p-3" style="background-color:#FFFCF7; font-size: 12px;">
				پورسانت هر جلسه
				<p class="font-weight-bold text-center" style="font-size: 16px;">
					{{ ["0", "10", "20", "30", "40", "5"][val.value.commission] }}
					درصد
				</p>
				<img :src="require('../../assets/img/commission.svg')" width="50" />
			</div>
		</div>
	</div>
	</div>
</template>

<script>
	import multi_step_progress from "../../UI/progress/multi_step_progress.vue";
	import btn from "../../UI/button/btn.vue";
	

	export default {
		name: 'wait_signup',
		data(){
			return {
			}
		},
		components: {
			btn,
			multi_step_progress,
		},
		props: {
			val: {
				default: {
					page: 1,
				},
			},
		},
		mounted(){

		},
		methods:{
		}
	}
</script>
<style>

</style>
